import { Box, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { clearOpenSections } from "components/app/App.slice";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import { setPlanMode } from "components/features/CustomPlanCreation/CustomPlanCreation.slice";
import CreatePlanButton from "components/features/MyPlans/Create/CreatePlanButton";
import Form from "components/features/MyPlans/Create/Form";
import { useTranslate } from "hooks/useTranslate";
import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { theme as MUITheme } from "styles/Theme";
import { tokens } from "styles/Tokens";
import { routes } from "utils/routes";
import { formTypes } from "utils/Types";

interface Props {
  formType?: string;
  label?: string;
  showMenu?: boolean;
  buttonSize?: any;
  sx?: any;
}

function CreateMyPlan(props: Readonly<Props>) {
  const { formType = formTypes.CreatePlan } = props;

  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { setIsOpenCustomPlanCreateDialog } = React.useContext(ActionCardDialogsContext);

  const { isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);
  const isMobileScreen = useMediaQuery(MUITheme.breakpoints.down("md"));
  const [createNewPlan, setCreateNewPlan] = useState(false);
  const [isTemplateType, setIsTemplateType] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const openCreateMenu = Boolean(anchorEl);
  const formRef: any = React.useRef(null);
  const formSubmit = () => formRef?.current?.submitForm();

  React.useEffect(() => {
    dispatch(clearOpenSections());
  }, [dispatch]);

  const handleCloseCreatePlanDialog = () => {
    setCreateNewPlan(false);
  };

  const getOnClickForCreatePlan = (event: React.MouseEvent<HTMLElement>) => {
    if (isAbovePropertyUser || props.showMenu) handleOpenCreateMenu(event);
    else {
      dispatch(setPlanMode(formType));
      setIsTemplateType(false);
      setIsOpenCustomPlanCreateDialog(true);
    }
  };

  const handleOpenCreateMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const MenuItems = {
    ABOVE_PROPERTY: [
      {
        id: 1,
        title: translate("myplan.PropertyPlan"),
        subtitle: translate("myplan.createPropertyPlan"),
        onClick: () => {
          dispatch(setPlanMode(formType));
          setAnchorEl(null);
          setIsTemplateType(false);
          setIsOpenCustomPlanCreateDialog(true);
        }
      },
      {
        id: 2,
        title: translate("myplan.TemplatePlan"),
        subtitle: translate("myplan.createTemplatePlan"),
        onClick: () => {
          dispatch(setPlanMode(formType));
          setAnchorEl(null);
          setIsTemplateType(true);
          setCreateNewPlan(true);
        }
      }
    ],
    HOTEL_USER: [
      {
        id: 3,
        title: "Create Custom Plan",
        subtitle: "Tailor the plan precisely to your needs",
        onClick: () => {
          dispatch(setPlanMode(formType));
          setIsOpenCustomPlanCreateDialog(true);
        }
      },
      {
        id: 4,
        title: "Add Library Plan",
        subtitle: "Save time by choosing from library plans",
        onClick: () => navigate(routes.Library)
      }
    ]
  };

  return (
    <>
      <CreatePlanButton {...props} getOnClickForCreatePlan={getOnClickForCreatePlan} />

      <Menu
        id="create-menu"
        anchorEl={anchorEl}
        open={openCreateMenu}
        onClose={() => {
          setAnchorEl(null);
        }}
        sx={{
          ".MuiList-root": {
            padding: "0",
            margin: "8px"
          }
        }}
      >
        {(isAbovePropertyUser ? MenuItems["ABOVE_PROPERTY"] : MenuItems["HOTEL_USER"]).map((item) => {
          return (
            <MenuItem key={item.id} onClick={item.onClick}>
              <Box>
                <Typography variant="body2" showBold sx={{ color: tokens.Text.General.PrimaryHeadline }}>
                  {item.title}
                </Typography>
                <Typography variant="label" sx={{ color: tokens.Text.General.Secondary, whiteSpace: "normal" }}>
                  {item.subtitle}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Menu>

      {createNewPlan && isTemplateType && (
        <DialogFormation
          title="Create Custom Plan"
          openDialog={createNewPlan}
          handleClose={handleCloseCreatePlanDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseCreatePlanDialog} />
              <Button variant="primary" label="Save" onClick={formSubmit} />
            </div>
          }
        >
          <div className="create-new-plan-child">
            <Form
              {...props}
              ref={formRef}
              handleCloseDialog={handleCloseCreatePlanDialog}
              isTemplateType={isTemplateType}
            />
          </div>
        </DialogFormation>
      )}
    </>
  );
}

export default CreateMyPlan;
